import { Component } from '@angular/core';
import { AuthService } from '@twaice-fe/frontend/shared/services';

@Component({
  templateUrl: './missing-configuration.component.html',
  selector: 'twaice-fe-missing-configuration',
  standalone: false,
})
export class MissingConfigurationComponent {
  constructor(private authService: AuthService) {}

  async signOut() {
    await this.authService.logout();
  }
}
